<template>
    <secition-card
        title="가입자"
        v-bind="{
            titleActionProps: { to: '/console/statistics/members' },
            loading,
        }"
        class="fill-height"
    >
        <v-data-table
            v-bind="{
                headers,
                items,
                'items-per-page': -1,
                'mobile-breakpoint': -1,
            }"
            hide-default-footer
            hide-default-header
            disable-filtering
            disable-pagination
            disable-sort
            dense
        >
            <template v-for="header in headers.filter((header) => header.hasOwnProperty('formatter'))" #[`item.${header.value}`]="{ value }"> {{ header.formatter(value) }} </template>
        </v-data-table>
    </secition-card>
</template>

<script>
import api from "@/api";

import SecitionCard from "@/components/console/dumb/secition-card.vue";
import { USER_TYPES } from "@/assets/variables";

export default {
    components: {
        SecitionCard,
    },
    props: {
        searchDateValue: { type: Array, default: () => [null, null] },
    },
    data: () => ({
        summary: {
            users: 0,
            persons: 0,
            companies: 0,
        },

        loading: false,
    }),
    computed: {
        headers() {
            return [
                {
                    text: "분류",
                    value: "_id",
                    formatter: (value) => value || "직접방문",
                },
                {
                    text: "회원수",
                    value: "count",
                    align: "end",
                    formatter: (value) => `${value?.format?.() || "-"}명`,
                },
            ].map((item) => ({ ...item, cellClass: `${item.cellClass || ""} text-caption` }));
        },
        items() {
            return [
                {
                    _id: "전체회원",
                    count: this.summary.users,
                },
                {
                    _id: "개인회원",
                    count: this.summary.persons,
                },
                {
                    _id: "기업회원",
                    count: this.summary.companies,
                },
            ];
        },
    },
    methods: {
        async search() {
            if (this.loading) return;
            else this.loading = true;

            try {
                const { searchDateValue } = this;

                const {
                    summary: { totalCount: users },
                } = await api.console.users.gets({
                    headers: { mode: "count-only" },
                    params: { searchDateValue },
                });
                this.summary.users = users;

                const {
                    summary: { totalCount: persons },
                } = await api.console.users.gets({
                    headers: { mode: "count-only" },
                    params: { searchDateValue, type: USER_TYPES.PERSON.value },
                });
                this.summary.persons = persons;

                const {
                    summary: { totalCount: companies },
                } = await api.console.users.gets({
                    headers: { mode: "count-only" },
                    params: { searchDateValue, type: USER_TYPES.COMPANY.value },
                });
                this.summary.companies = companies;
            } finally {
                this.loading = false;
                this.$emit("updated");
            }
        },
    },
    watch: {
        searchDateValue() {
            this.search();
        },
    },
    mounted() {
        this.search();
    },
};
</script>

<style>
</style>